import { sanitizeSlug } from '@helpers/sanitizeSlug';
import { useState } from 'react';

export const useNameWithSlug = () => {
  const [name, setNameValue] = useState('');
  const [slug, setSlugValue] = useState('');
  const [isSlugEdited, setIsSlugEdited] = useState(false);

  const setName = (value: string) => {
    setNameValue(value);
    if (!isSlugEdited) {
      setSlugValue(sanitizeSlug(value));
    }
  };

  const setSlug = (value: string) => {
    setIsSlugEdited(true);
    setSlugValue(value);
  };

  return { name, slug, setName, setSlug };
};
